var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var hs = Array.from(Array(16), function (_, i) { return i.toString(16); });
var hsr = hs.slice().reverse();
var h2s = hs.join("").match(/../g), h2sr = hsr.join("").match(/../g);
var h2mix = hs.map(function (h, i) { return "".concat(hsr[i]).concat(h); });
var hseq = h2s === null || h2s === void 0 ? void 0 : h2s.concat(h2sr, h2mix).map(function (hex) { return parseInt(hex, 16); });
var H = new Uint32Array(Uint8Array.from(hseq.slice(0, 20)).buffer);
var K = Uint32Array.from([2, 3, 5, 10], function (v) { return Math.floor(Math.sqrt(v) * (Math.pow(2, 30))); });
var F = [
    function (b, c, d) { return ((b & c) | ((~b >>> 0) & d)) >>> 0; },
    function (b, c, d) { return b ^ c ^ d; },
    function (b, c, d) { return (b & c) | (b & d) | (c & d); },
    function (b, c, d) { return b ^ c ^ d; },
];
function rotl(v, n) {
    return ((v << n) | (v >>> (32 - n))) >>> 0;
}
export function sha1(buffer) {
    var _a;
    var u8a = ArrayBuffer.isView(buffer) ?
        new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) :
        new Uint8Array(buffer);
    var total = Math.ceil((u8a.length + 9) / 64) * 64;
    var chunks = new Uint8Array(total);
    chunks.set(u8a);
    chunks.fill(0, u8a.length);
    chunks[u8a.length] = 0x80;
    var lenbuf = new DataView(chunks.buffer, total - 8);
    var low = u8a.length % (1 << 29);
    var high = (u8a.length - low) / (1 << 29);
    lenbuf.setUint32(0, high, false);
    lenbuf.setUint32(4, low << 3, false);
    var hash = H.slice();
    var w = new Uint32Array(80);
    for (var offs = 0; offs < total; offs += 64) {
        var chunk = new DataView(chunks.buffer, offs, 64);
        for (var i = 0; i < 16; i++)
            w[i] = chunk.getUint32(i * 4, false);
        for (var i = 16; i < 80; i++) {
            w[i] = rotl(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16], 1);
        }
        var _b = __read(hash, 5), a = _b[0], b = _b[1], c = _b[2], d = _b[3], e = _b[4];
        for (var s = 0; s < 4; s++) {
            for (var i = s * 20, end = i + 20; i < end; i++) {
                var ne = rotl(a, 5) + F[s](b, c, d) + e + K[s] + w[i];
                _a = __read([ne >>> 0, a, rotl(b, 30), c, d], 5), a = _a[0], b = _a[1], c = _a[2], d = _a[3], e = _a[4];
            }
        }
        hash[0] += a;
        hash[1] += b;
        hash[2] += c;
        hash[3] += d;
        hash[4] += e;
    }
    var digest = new DataView(new ArrayBuffer(20));
    hash.forEach(function (v, i) { return digest.setUint32(i * 4, v, false); });
    return digest.buffer;
}
